// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "client/" + "post-actions" + ".chunk.min.css";
};